import { defineStore } from 'pinia';

export const use_is_single_site_store = defineStore('is_single_site', {
  state: () => ({
    is_single_site: true,
  }),
  getters: {
    get_is_single_site: (state) => state.is_single_site,
  },
  actions: {
    set_is_single_site(is_single_site) {
      this.is_single_site = is_single_site;
    },
  },
});
